













import { Vue, Component } from "vue-property-decorator";

@Component({
  name: "QNav",
  components: {},
})
export default class QNav extends Vue {
  mounted() {
    // this.fetchUser();
  }
}
